export default __webpack_public_path__ + "static/media/grid10.a2cbd115.png";